<template>
  <div class="the-cover">
    <div class="title-wrapper">
      <h1 v-html="title"></h1>
    </div>

    <picture>
      <source media="all and (orientation: landscape)" :srcset="`${publicPath}${brand}/cover.jpg`">
      <img :src="`${publicPath}${brand}/cover-mobile.jpg`" :alt="title" />
    </picture>
  </div>
</template>

<script>
import { brand, title } from '../../content'

export default {
  name: 'UiTheCover',

  data() {
    return {
      brand,
      publicPath: process.env.BASE_URL,
      title
    }
  }
}
</script>

<style lang="scss" scoped>
.the-cover {
  min-height: 100vh;
  @media screen and (min-width: 996px) {
    position: relative;
    z-index: 400;
  }
}

.title-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  padding: 60px 0 10vh;
  z-index: 9;
}

h1 {
  position: absolute;
  bottom: 50%; // royalsalute, legend, glenmorangie, jw, singleton
  // bottom: 40%; // glenlivet
  left: 50%;
  transform: translate(-50%, 80%);
  width: 95%;
  font-family: source-han-serif-tc, 'Songti TC', serif;
  font-size: 34px;
  font-weight: 700;
  line-height: 1.44;
  color: #fff;
  text-shadow: 0 6px 8px rgba(#000, 0.6);
  text-align: center;
  &:deep {
    .desktop-only {
      display: none;
    }
  }
  @media screen and (min-width: 996px) {
    // left: 25%; // glenlivet
    bottom: 25%; // royalsalute, legend, glenmorangie, jw, singleton
    // bottom: 50%; // glenlivet
    transform: translateX(-50%);
    font-size: 60px;
    line-height: 1.4;
    max-width: 960px;
    &:deep {
      .mobile-only {
        display: none;
      }
      .desktop-only {
        display: inline;
      }
    }
  }
}

picture {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: block;
  height: 100%;
}

img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
}
</style>